import React, { FormEvent, useState } from 'react'
import FormInputField from '../../components/forms/inputs/FormInputField'
import { Button } from '@mantine/core'
import { GET_INSPECTIONS } from '../../graphql/queries';
import { useLazyQuery } from '@apollo/client';
import { getDataFromRecord } from './config';

export default function InspectInitForm({ proceed }: { proceed: (data: any, inspectionId?: number, wasDefects?: string[], inspection?: any) => void }) {
   const [vehicleReg, setVehicleReg] = useState()
   const [getInspections, { loading }] = useLazyQuery(GET_INSPECTIONS, {
      fetchPolicy: "network-only",
   });
   const onSubmit = (ev: FormEvent) => {
      ev.preventDefault()
      console.log({ vehicleReg })
      let vars: any = {
         vehicleNo: vehicleReg,
         limit: 1,
      }
      getInspections({
         variables: vars
      }).then((res) => {
         if (res.data) {
            let resData = res.data.getAllInspections;
            console.log({ vehicleReg, resData })
            let inspection = resData?.records[0]
            console.log({ inspection })
            let data = new Map([["vehicleReg", vehicleReg]])
            let wasDefects = []
            let inspectionId = undefined
            if (inspection) {
               let defects = inspection.checklists.filter((c: any) => !["Compliant"].includes(c.optionValue))
               if (defects && defects.length) {
                  data = getDataFromRecord(inspection)
                  data.set("vehicleReg", vehicleReg)
                  wasDefects = defects.map((c: any) => `item-${c.itemId}`)
                  inspectionId = inspection?.id
               }
            }
            proceed(data, inspectionId, wasDefects, inspection)
         }
      });
   }
   const handleUpperCase = (e: any) => {
      e.target.value = ("" + e.target.value).toUpperCase();
   }
   return (
      <div className='flex'>
         <form onSubmit={onSubmit} className='flex gap-2 items-end w-full'>
            <div className='flex-1'>
               <FormInputField options={{
                  required: true, onInput: handleUpperCase
               }}
                  onChange={({ name, value }: any) => {
                     setVehicleReg(value)
                  }}
                  name='vehicleReg' label='Vehicle Reg No' />
            </div>
            <Button type='submit'>{loading ? "Checking ..." : "Check Pending Inspections"}</Button>
         </form>
      </div>
   )
}
